import logoLight from "../Assets/logos/logo-light.png";
import logoDark from "../Assets/logos/logo-dark.png";
import logoTeal from "../Assets/logos/logo-teal.png";
import logoWhite from "../Assets/logos/logo-white.png";
import logoNobg from "../Assets/logos/logo-nobg.png";
import logoIconDark from "../Assets/logos/logo-icon-dark.png";
import logoIconLight from "../Assets/logos/logo-icon-light.png";
import logoIconTeal from "../Assets/logos/logo-icon-teal.png";
import logoIconWhite from "../Assets/logos/logo-icon-white.png";
import logoIconNobg from "../Assets/logos/logo-icon-nobg.png";

const AssetConfig = {
  logoLight,
  logoDark,
  logoTeal,
  logoWhite,
  logoNobg,
  logoIconDark,
  logoIconLight,
  logoIconTeal,
  logoIconWhite,
  logoIconNobg,
};

export default AssetConfig;
